
export class CellController {
    validLetter(letter: string): boolean {
        
        const pattern = /^[A-za-zåäöÅÄÖ]{1}$/;
        return pattern.test(letter);
    }
}


export const CellControllerImpl = new CellController();